import { IconButton } from '@material-ui/core';
import { headerHeight, headerPaddingBottom } from 'components/base/header/AppHeader';
import { icon_delete, icon_go_back, icon_modify_w } from 'components/base/images';
import PageTitle from 'components/base/title/PageTitle';
import MuiButton from 'components/common/button/MuiButton';
import ImgCrop from 'components/common/images/ImgCrop';
import { T } from 'components/common/text';
import CustomSpan from 'components/common/text/CustomSpan';
import CustomText from 'components/common/text/CustomText';
import { genderList, pageUrl } from 'lib/mapper';
import { IPatientInfo } from 'lib/types/patientTypes';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { color } from 'styles/utils';

interface PatientProps {
  language: string;
  hasAlarm: any;
  patientInfo: IPatientInfo;
  onOpenDeletePatientModal: () => void;
  onOpenModifyPatientModal: () => void;
  profileFilePreview: any;
}

function Patient({
  language,
  hasAlarm,
  // indicationFormat,
  // indicationInfo,
  patientInfo,
  onOpenDeletePatientModal,
  onOpenModifyPatientModal,
  profileFilePreview,
}: // isProjectCreator,
// managerList,
// prevPartnerManager,
// partnerManager,
// onOpenDeletePatientModal,
// onChangePartnerManager,
// onEditProjectSync,
// onEditRework,
PatientProps) {
  const { t } = useTranslation();
  const {
    chartNumber,
    firstName,
    lastName,
    identification,
    birthday,
    gender,
    comment,
    patientCode,
    patientCodeIdx,
    profileImgIdx,
    profileImg,
  } = patientInfo;
  const [goldStatusModalOpen, setGoldStatusModalOpen] = useState(false);
  const history = useHistory();

  const handleCloseGoldStatusModal = () => setGoldStatusModalOpen(false);
  const handleGoToBack = () => {
    history.push(pageUrl.patient.list);
  };

  // const [profileFilePreview, setProfileFilePreview] = useState<object | any>(null);

  // useEffect(() => {
  //   if (!patientInfo.profileImgIdx) {
  //     // NOTE: 프로필 이미지 없는경우 디폴트 이미지
  //     const patientAge = calculateAge(patientInfo.birthday);
  //     if (patientAge.isAdult) {
  //       if (patientInfo.gender === 'F') {
  //         setProfileFilePreview(profile_female);
  //       } else {
  //         setProfileFilePreview(profile_male);
  //       }
  //     } else {
  //       if (patientInfo.gender === 'F') {
  //         setProfileFilePreview(profile_girl);
  //       } else {
  //         setProfileFilePreview(profile_boy);
  //       }
  //     }
  //   } else {
  //     // TODO: 프로필 이미지있는 경우, 프로필이미지 다운로드 추가 예정
  //     // setProfileFilePreview()
  //   }
  // }, []);

  // const genderList: any = {
  //   M: 'Male',
  //   F: 'Female',
  //   N: 'None',
  // };

  return (
    <StyledProject data-component-name="Patient">
      <PageTitle title={'Patient Edit'} className="sr-only" />
      <div className="patient__back_button_box">
        {/* <StageTimeline stage={stage} timeline={timeline} /> */}
        <IconButton className="patient__back_button" onClick={handleGoToBack}>
          <img className="patient__go_back_btn" src={icon_go_back} />
        </IconButton>
        <p className="patient__back_to_page">
          <T>PROJECT_BACK_TO_PAGE</T>
        </p>
      </div>
      <div className="patient__info_box">
        <div className="patient__info_title">
          <CustomText fontSize={24} color="#222" fontWeight={500}>
            <T>PATIENT_INFO_TITLE</T>
          </CustomText>
        </div>
        <div className="patient__info_contents">
          <div className="patient__info_image">
            {/* <img src={profile_male} /> */}
            <ImgCrop width={166} height={200} src={profileFilePreview} />
          </div>

          <div className="patient__infor_detail">
            <div className="patient__info_item chartNo">
              <div className="patient__info_item_title">
                <CustomText fontSize={14} color="#222" fontWeight="500">
                  <T>PATIENT_INFO_CHART_NUM</T>
                </CustomText>
              </div>
              <div className="patient__info_item_value">
                <CustomText fontSize={14} color="#444">
                  {chartNumber}
                </CustomText>
              </div>
            </div>

            <div className="patient__info_item firstName">
              <div className="patient__info_item_title">
                <CustomText fontSize={14} color="#222" fontWeight="500">
                  <T>PATIENT_INFO_FIRST_NAME</T>
                </CustomText>
              </div>
              <div className="patient__info_item_value">
                <CustomText fontSize={14} color="#444">
                  {firstName}
                  {!!identification ? identification : ''}
                </CustomText>
              </div>
            </div>

            <div className="patient__info_item lastName">
              <div className="patient__info_item_title">
                <CustomText fontSize={14} color="#222" fontWeight="500">
                  <T>PATIENT_INFO_LAST_NAME</T>
                </CustomText>
              </div>
              <div className="patient__info_item_value">
                <CustomText fontSize={14} color="#444">
                  {!!lastName ? lastName : '-'}
                </CustomText>
              </div>
            </div>

            <div className="patient__info_item birthday">
              <div className="patient__info_item_title">
                <CustomText fontSize={14} color="#222" fontWeight="500">
                  <T>PATIENT_INFO_BIRTH_DAY</T>
                </CustomText>
              </div>
              <div className="patient__info_item_value">
                <CustomText fontSize={14} color="#444">
                  {!!moment(birthday).isValid() ? moment(birthday).format('YYYY/MM/DD') : '-'}
                </CustomText>
              </div>
            </div>

            <div className="patient__info_item gender">
              <div className="patient__info_item_title">
                <CustomText fontSize={14} color="#222" fontWeight="500">
                  <T>PATIENT_INFO_GENDER</T>
                </CustomText>
              </div>
              <div className="patient__info_item_value">
                <CustomText fontSize={14} color="#444">
                  {genderList[gender as keyof typeof genderList]}
                </CustomText>
              </div>
            </div>
          </div>

          <div className="patient__info_line" />

          <div className="patient__info_comment">
            <div className="patient__info_comment_title">
              <CustomSpan fontSize={14} color="#444" fontWeight="500">
                <T>PATIENT_INFO_COMMENT</T>
              </CustomSpan>
            </div>
            <div className="patient__info_comment_memo">
              <CustomText
                fontSize={14}
                color="#444"
                style={{ lineHeight: '1.5', whiteSpace: 'pre-line' }}
              >
                {comment}
              </CustomText>
            </div>
          </div>
          <div className="patient__info_button">
            <MuiButton
              config={{
                width: 120,
                borderColor: color.gray_b5,
                bgColor: 'white',
              }}
              variant="outlined"
              className="sm"
              startIcon={<img src={icon_delete} />}
              onClick={onOpenDeletePatientModal}
            >
              <T>GLOBAL_DELETE</T>
            </MuiButton>
            <MuiButton
              config={{
                width: 200,
                borderColor: color.blue,
                bgColor: 'white',
              }}
              variant="contained"
              disableElevation
              className="sm"
              startIcon={<img src={icon_modify_w} />}
              onClick={onOpenModifyPatientModal}
            >
              <T>GLOBAL_MODIFY</T>
            </MuiButton>
          </div>
        </div>
      </div>
    </StyledProject>
  );
}

export default React.memo(Patient);

const StyledProject = styled.div`
  .patient__back_button_box {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    /* margin-top: -${headerHeight}px; */
    margin-top: -80px;
    width: calc(100% - 100px - 200px);
    /* height: ${headerHeight}px; */
    height: 100px;
    /* padding-bottom: ${headerPaddingBottom}px; */
    /* padding-top: 15px;
    padding-left: 40px; */
    .patient__back_button {
      background-color: #ffffff;
      width: 54px;
      height: 54px;
      overflow: hidden;
      border-radius: 50%;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      &:hover {
        cursor: pointer;
      }
    }
    .patient__back_to_page {
      font-size: 20px;
      color: #888;
    }
  }
  .patient__info_box {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    .patient__info_title {
    }
    .patient__info_contents {
      display: flex;
      width: 100%;
      height: 260px;
      border-radius: 10px;
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
      background-color: #fff;
      padding: 30px;
      .patient__info_image {
        margin-right: 40px;
      }
      .patient__infor_detail {
        display: flex;
        flex-direction: column;
        margin-right: 100px;
        .patient__info_item {
          display: flex;
          .patient__info_item_title {
            width: 140px;
            height: 40px;
            display: flex;
            align-items: center;
          }
          .patient__info_item_value {
            width: 150px;
            height: 40px;
            display: flex;
            align-items: center;
          }
        }
      }
      .patient__info_line {
        width: 1px;
        height: 100%;
        background-color: #ccccd4;
        margin-right: 30px;
      }
      .patient__info_comment {
        height: 100%;
        display: flex;
        flex-direction: column;
        .patient__info_comment_title {
          margin-bottom: 16px;
        }
        .patient__info_comment_memo {
          width: 417px;
          height: 100%;
          padding: 20px;
          border-radius: 5px;
          border: solid 1px #ccccd4;
          background-color: #fff;
          overflow: overlay;
        }
      }
      .patient__info_button {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        column-gap: 10px;
      }
    }
  }
`;
